import React, { Component } from "react";
import { connect } from "react-redux";
import actions from "../../actions/actions";
import SearchBox from "../../components/SearchBox/SearchBox";
import PaginatedListComponent from "../../components/Pagination/PaginatedListComponent";
import SwitchButton from "../../components/Buttons/SwitchButton";
import PaginationSection from "../../components/Pagination/PaginationSection";
import Button from "../../components/Buttons/Button";
import JobRepository from "../../repositories/JobRepository";
import CustomerCell from "../../components/Customers/CustomerCell"
import JobRow from "../../components/Jobs/JobRow";
import CustomerRepository from "../../repositories/CustomerRepository";

class CustomerIndex extends Component {
	constructor(props) {
		super(props);
		this.displayNotification = this.displayNotification.bind(this);
		this.state = {
			currentPage: 1,
			searchTerm: "",
			parts: [],
			totalPages: 0,
			activeButton: 1,
			renderMode: "grid",
		};
		this.search = this.search.bind(this);
		this.toggleRenderMode = this.toggleRenderMode.bind(this);
	}

	displayNotification() {
		this.props.dispatch(actions.addNotification("test", "desc"));
	}

	search(searchTerm) {
		this.setState({ searchTerm });
	}

	toggleRenderMode(mode) {
		let activeButton = 0;
		if (mode === "grid") {
			activeButton = 1;
		}
		this.setState({ renderMode: mode, activeButton });
	}

	renderParts(mode, customer) {
		if (mode == "grid") {
			return <CustomerCell key={customer.objectId} customer={customer} />;
		} else {
			return <JobRow key={customer.objectId} customer={customer} />;
		}
	}

	render() {
		return (
			<div>
				<div className="bg-dark">
					<div className="row p-t-20 p-b-10">
						<div className="col-md-6 text-center mx-auto text-white">
							<div className="form-dark headerSearchBar">
								<SearchBox responseFunction={this.search} placeHolder="Search Customers"></SearchBox>
								<SwitchButton
									onClick={this.toggleRenderMode}
									activeButton={this.state.activeButton}
									aButton={{
										name: <i className="mdi mdi-view-headline" />,
										value: "list",
									}}
									bButton={{
										name: <i className="mdi mdi-view-grid" />,
										value: "grid",
									}}
								/>
							</div>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-2">
						<div className="row">
							<div className="card m-b-30 partFilter">
								<div className="card-header">
									<h5 className="m-b-0">Filter</h5>
									<p className="m-b-0 text-muted">Filter Customers</p>
								</div>
								<div className="card-body">
									<div className="m-b-10">
										<label> Slider</label>
									</div>
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col-12">
								<Button className="btn-primary" href="/wizard">Create new job</Button>
							</div>
						</div>
					</div>
					<div className="col-10">
						<PaginatedListComponent
							searchTerm={this.state.searchTerm}
							displayMode="grid"
							tableHeaders={["Name", "State", "Creation Date", ""]}
							renderer={this.renderParts}
							loadFunction={CustomerRepository.GetCustomerPage}
							hasDisplayToggle={false}
							displayMode={this.state.renderMode}
						/>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = function(state) {
	return state.notificationReducer;
};

export default connect(mapStateToProps)(CustomerIndex);
